import location from './location'
import activity from './activity'

export default {
  name: 'GeoLocation',
  path: 'location',
  meta: {
    label: 'geoLocation',
    auth: 'location'
  },
  component: {
    name: 'Location',
    render(c) {
      return c('router-view')
    }
  },
  children: [location, activity]
}
